import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getTransactionInbox, updateTransactionById } from '../../util/api';
import { makeStrapiFilters } from '../../config/configStrapiUrls.js';
import { fetchCurrentUser, fetchCurrentUserNotifications } from '../../ducks/user.duck';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/InboxPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/InboxPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/InboxPage/FETCH_ORDERS_OR_SALES_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersOrSalesError: null,
  pagination: null,
  transactionRefs: [],
};
export default function inboxPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_OR_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersOrSalesError: null };
    case FETCH_ORDERS_OR_SALES_SUCCESS: {

      const transactions = sortedTransactions(payload.data.data);

      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_OR_SALES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchOrdersOrSalesError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = response => ({
  type: FETCH_ORDERS_OR_SALES_SUCCESS,
  payload: response,
});
const fetchOrdersOrSalesError = e => ({
  type: FETCH_ORDERS_OR_SALES_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //
export const updateTransaction = (params) => (dispatch, getState, sdk) => {

  const { updateParams } = params;

  return updateTransactionById(updateParams)
    .then(response => {
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      throw e;
    });
};

const INBOX_PAGE_SIZE = 10;

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const { tab } = params;

  const onlyFilterValues = {
    orders: 'order',
    sales: 'sale',
  };

  const onlyFilter = onlyFilterValues[tab];
  if (!onlyFilter) {
    return Promise.reject(new Error(`Invalid tab for InboxPage: ${tab}`));
  }

  dispatch(fetchOrdersOrSalesRequest());

  const { page = 1 } = parse(search);

  return Promise.all([dispatch(fetchCurrentUser())])
    .then(response => {
      const currentUser = getState().user?.currentUser;
      const userId = currentUser?.id?.uuid;
      // filters[id][$in][0]=6
      const searchFilterArray = [
        { type: "pagination", keyName: "page", keyFilter: "", keyValue: page },
        { type: "pagination", keyName: "pageSize", keyFilter: "", keyValue: INBOX_PAGE_SIZE },
        { type: "filters", keyName: onlyFilter == "sale" ? "providerId" : "customerId", keyFilter: "$eq", keyValue: userId },
        { type: "sort", keyName: "id", keyFilter: "", keyValue: "desc" }
      ];

      const searchFilter = makeStrapiFilters(searchFilterArray)

      getTransactionInbox({ searchFilter })
        .then(response => {
          dispatch(addMarketplaceEntities(response));
          dispatch(fetchOrdersOrSalesSuccess(response));
          return response;
        })
        .catch(e => {
          dispatch(fetchOrdersOrSalesError(storableError(e)));
          throw e;
        });
      return response;
    })
    .catch(e => {
      throw e;
    });
};
